import { useMemo } from 'react'
import { useRouteMatch } from 'react-router-dom'

import { useHomeTabs } from 'hooks/home/tabs'

const nonIdScopeTypes = [
  'all_users_and_teams',
  'users',
  'teams',
]

export const useScope = () => {
  const { getTabScopeV2 } = useHomeTabs()
  const { type, id } = getTabScopeV2()
  const { params } = useRouteMatch()

  const scopeType = useMemo(() => {
    if (params.scopeType) {
      return params.scopeType
    }

    if (type) {
      return type
    }

    return null
  }, [type, params])

  const scopeId = useMemo(() => {
    if (nonIdScopeTypes.includes(scopeType)) {
      return null
    }

    if (params.scopeId) {
      return params.scopeId
    }

    if (id) {
      return id
    }

    return null
  }, [id, params, scopeType])

  return { scopeType, scopeId }
}
